import { Link } from 'react-router-dom';
import styles from './FatigueTypeformLink.module.scss';

interface Props {
  email?: string;
  fullName?: string;
}

export const FatigueTypeformLink = ({ email, fullName }: Props) => {
  // const [option, setOption] = useState(Options.Wellbeing);

  if (!email || !fullName) {
    return <></>;
  }

  const formId = process.env.REACT_APP_FATIGUE_FORM_ID;

  const link = `https://percihealth.typeform.com/to/${formId}#email=${encodeURIComponent(
    email,
  )}&name=${encodeURIComponent(fullName)}&source=manual`;

  return (
    <div className={styles.container}>
      <Link to={link} target="_blank">
        {`Add "Fatigue" form`}
      </Link>
    </div>
  );
};
